var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiceLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.7 66.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-miterlimit: 10;\n      }\n\n      .st0, .st1 {\n        fill: #fff;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6 {\n        stroke: #000;\n      }\n\n      .st7 {\n        stroke: #fff;\n      }\n\n      .st7, .st1, .st2, .st3, .st4, .st5, .st6 {\n        stroke-linejoin: round;\n      }\n\n      .st7, .st2, .st3 {\n        fill: none;\n      }\n\n      .st3 {\n        stroke-width: 4px;\n      }\n\n      .st8 {\n        display: none;\n      }\n\n      .st4 {\n        fill: #666766;\n      }\n\n      .st5 {\n        fill: #333;\n      }\n\n      .st6 {\n        fill: #999;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "d20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.3 64.1 58.7 46.7 49.4 46.7 32.3 64.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "49.4 46.7 58.7 19.2 58.7 46.7 49.4 46.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.3 15.4 32.3 2 58.7 19.2 32.3 15.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.3 15.4 49.4 46.7 58.7 19.2 32.3 15.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.3 64.1 5.9 46.7 15.2 46.7 32.3 64.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "15.2 46.7 5.9 19.2 5.9 46.7 15.2 46.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.3 15.4 32.3 2 5.9 19.2 32.3 15.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.3 15.4 15.2 46.7 5.9 19.2 32.3 15.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "15.2 46.7 32.3 15.4 49.4 46.7 15.2 46.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.3 64.1 15.2 46.7 49.4 46.7 32.3 64.1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    className: "st8"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0.4,
    y1: 1.1,
    x2: 64.4,
    y2: 65.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 64.4,
    y1: 1.1,
    x2: 0.4,
    y2: 65.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "d2",
    className: "st8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 32.3,
    cy: 33,
    r: 24.4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d4",
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "7.9 54.2 32.4 11.8 56.9 54.2 7.9 54.2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "d6",
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 11.2,
    y: 11.9,
    width: 42.3,
    height: 42.3
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "d8",
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6 49.4 32.4 1.9 58.7 49.4 6 49.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "58.7 49.4 32.4 1.9 58.8 18.7 58.7 49.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "6 49.4 58.7 49.4 32.4 64.2 6 49.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "6 49.4 5.9 18.7 32.4 1.9 6 49.4"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "d10",
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "32.4 2.9 12.2 41.4 32.4 51 52.5 41.4 32.4 2.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "52.5 41.4 32.4 2.9 63.4 26.3 63.4 41.1 52.5 41.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "32.4 63.2 32.4 51 52.5 41.4 63.4 41.1 32.4 63.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "12.2 41.4 32.4 2.9 1.3 26.3 1.3 41.1 12.2 41.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "32.4 63.2 32.4 51 12.2 41.4 1.3 41.1 32.4 63.2"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "d12",
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "32.4 13 14 26.4 20.7 48.6 44 48.6 50.7 26.4 32.4 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "44 48.6 50.7 26.4 61.2 22.9 61.2 42.4 50.6 57.7 44 48.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "50.7 26.4 32.4 13 32.4 1.9 49.4 7.6 61.2 22.9 50.7 26.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "32.4 13 14 26.4 3.5 22.9 15.3 7.6 32.4 1.9 32.4 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "14 26.4 20.7 48.6 14.2 57.7 3.5 42.4 3.5 22.9 14 26.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "20.7 48.6 44 48.6 50.6 57.7 32.4 64.2 14.2 57.7 20.7 48.6"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "d201"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "32.3 64 58.7 46.5 49.4 46.5 32.3 64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "49.4 46.5 58.7 19 58.7 46.5 49.4 46.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "32.3 15.2 32.3 1.9 58.7 19 32.3 15.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "32.3 15.2 49.4 46.5 58.7 19 32.3 15.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "32.3 64 5.9 46.5 15.2 46.5 32.3 64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "15.2 46.5 5.9 19 5.9 46.5 15.2 46.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "32.3 15.2 32.3 1.9 5.9 19 32.3 15.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "32.3 15.2 15.2 46.5 5.9 19 32.3 15.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "15.2 46.5 32.3 15.2 49.4 46.5 15.2 46.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "32.3 64 15.2 46.5 49.4 46.5 32.3 64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceLogo);
export default __webpack_public_path__ + "static/media/dice_logo.5328888e7ae03c26ff6d1e9297962d26.svg";
export { ForwardRef as ReactComponent };